export default "__VITE_ASSET__a4913e3a__"